import Vue from "vue";
import Router from "vue-router";
import store from "./store";
Vue.use(Router);

const routes = [
  {
    path: "/",
    component: () => import("@/views"),
    children: [
      {
        name: "Login",
        path: "login",
        component: () => import("@/views/customer/Login")
      },
      {
        name: "Register",
        path: "register",
        component: () => import("@/views/customer/Register")
      },
      {
        path: "/dinein",
        component: () => import("@/views/dinein/Index"),
        children: [
          {
            name: "DineIn",
            path: "/",
            component: () => import("@/views/dinein/DineIn")
          }
        ]
      },
      {
        path: "/",
        component: () => import("@/views/home/Index"),
        children: [
          // {
          //   name: "Landing",
          //   path: "/",
          //   component: () => import("@/views/home/Landing")
          // },
          {
            name: "Contact",
            path: "/contact",
            component: () => import("@/views/home/Contact")
          },
          {
            name: "Term",
            path: "/tnc",
            component: () => import("@/views/home/Tnc")
          },
          {
            name: "Policy",
            path: "/policy",
            component: () => import("@/views/home/Policy")
          },
          {
            name: "LiveOrder",
            path: "/liveorder",
            component: () => import("@/views/payment/Summary")
          },
          {
            name: "Checkout",
            path: "/checkout",
            component: () => import("@/views/payment/Checkout")
          },
          {
            name: "Payment",
            path: "/payment",
            component: () => import("@/views/payment/Payment")
          },
          {
            path: "customer",
            component: () => import("@/views/customer/Index"),
            children: [
              {
                name: "Cart",
                path: "cart",
                component: () => import("@/views/customer/Cart")
              },
              {
                name: "Profile",
                path: "profile",
                component: () => import("@/views/customer/Profile")
              },
              {
                name: "Orders",
                path: "orders",
                component: () => import("@/views/customer/Order")
              },
              {
                name: "History",
                path: "history",
                component: () => import("@/views/customer/History")
              },
              {
                name: "Favourite",
                path: "favourite",
                component: () => import("@/views/customer/Favourite")
              }
            ]
          },
          {
            path: "promotions",
            component: () => import("@/views/promotion/Index"),
            children: [
              {
                name: "Promotions",
                path: "",
                component: () => import("@/views/promotion/Promotions")
              },
              {
                name: "PromotionsHistory",
                path: "history",
                component: () => import("@/views/promotion/PromotionsHistory")
              },
              // {
              //   name: "PromotionsMerchant",
              //   path: ":merchantId",
              //   component: () => import("@/views/promotion/PromotionsMerchant")
              // },
              {
                name: "PromotionDetails",
                path: ":promoID",
                component: () => import("@/views/promotion/PromotionDetails")
              }
            ]
          },
          {
            path: "/",
            component: () => import("@/views/home/Home"),
            children: [
              {
                name: "Home",
                path: "/",
                component: () => import("@/views/home/Main")
              },
              {
                path: ":merchant",
                component: () => import("@/views/merchant/Index"),
                children: [
                  {
                    name: "Merchant",
                    path: "",
                    component: () => import("@/views/merchant/StoreList")
                  },
                  {
                    name: "Store",
                    path: ":store",
                    component: () => import("@/views/merchant/StorePage")
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  var isAuthenticated = store.getters.isLoggedIn;

  // if (to.name == "Register") next();
  // else if (to.name !== "Login" && !isAuthenticated) next({ name: "Login" });
  // else if (to.name == "Login" && isAuthenticated) next({ name: "Home" });
  // else next();

  next();
});

export default router;
